<template>
  <v-card v-if="media.image || media.video" class="mb-4" outlined>
    <v-tabs v-model="mediaTab" grow>
      <v-tab v-if="media.image">Imatge</v-tab>
      <v-tab v-if="media.video">Vídeo</v-tab>
    </v-tabs>
    <v-tabs-items v-model="mediaTab">
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
        v-if="media.image"
      >
        <img :src="media.image" class="mb-2" width="100%" />
      </v-tab-item>
      <v-tab-item
        transition="fade-transition"
        reverse-transition="fade-transition"
        :disabled="media.video === null"
        v-if="media.video"
      >
        <iframe
          class="prd-item-dialog--iframe"
          :src="media.video"
          frameborder="0"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
export default {
  props: {
    media: {
      type: Object,
      default: () => ({
        image: null,
        video: null,
      }),
    },
  },
  data: () => ({
    mediaTab: 0,
  }),
}
</script>

<style scoped lang="scss">
.prd-item-dialog--iframe {
  width: 100%;
  height: 50vh;
  max-height: 400px;
  min-height: 100px;
}
.v-tab {
  border-bottom: 1px #00bba7 solid;
  &--active {
    color: white;
    /*TODO - #00bba7 primary color, not hardcoded*/
    background-color: #00bba7;
  }
}
</style>
